export const COVERAGE_FETCH_MAX_RETRIES = 3;
export const COVERAGE_FETCH_INITIAL_DELAY_MS = 1000;

function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

/**
 * Retry an async fetch fn with exponential backoff (transient network / 5xx).
 */
export async function fetchWithRetries(
    fn,
    {
        maxRetries = COVERAGE_FETCH_MAX_RETRIES,
        initialDelayMs = COVERAGE_FETCH_INITIAL_DELAY_MS,
        sleepFn = sleep,
    } = {},
) {
    let lastError;
    for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
        try {
            return await fn();
        } catch (err) {
            lastError = err;
            if (attempt < maxRetries) {
                await sleepFn(initialDelayMs * (2 ** attempt));
                continue;
            }
        }
    }
    throw lastError;
}
